import { render, staticRenderFns } from "./CategoriaNuevoEditar.vue?vue&type=template&id=3d655944&"
import script from "./CategoriaNuevoEditar.vue?vue&type=script&lang=js&"
export * from "./CategoriaNuevoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports